/* global plausible, document, window */
var html = document.documentElement;
var body = document.body;
var lastMonth;
var lastGroup;
var timeout;
var st = 0;

cover();
// subMenu();
featured();
feedLayout();
pagination();
archive();
video();
gallery();
table();
// burger();

window.addEventListener('scroll', function () {
    'use strict';
    if (body.classList.contains('home-template') && body.classList.contains('with-full-cover')) {
        if (timeout) {
            window.cancelAnimationFrame(timeout);
        }
        timeout = window.requestAnimationFrame(portalButton);
    }
});

function portalButton() {
    'use strict';
    st = window.scrollY;

    if (st > 300) {
        body.classList.add('portal-visible');
    } else {
        body.classList.remove('portal-visible');
    }
}

function cover() {
    'use strict';
    var cover = document.querySelector('.cover');
    if (!cover) return;

    imagesLoaded(cover, function () {
        cover.classList.remove('image-loading');
    });

    document.querySelector('.cover-arrow').addEventListener('click', function () {
        var element = cover.nextElementSibling;
        element.scrollIntoView({behavior: 'smooth', block: 'start'});
    });
}

function subMenu() {
    'use strict';
    var toggle = document.querySelector('.menu-item-resources');
    var back = document.querySelector('.gh-head-drop-back');

    toggle.addEventListener('click', function (e) {
        e.preventDefault();

        if (!body.classList.contains('dropdown-opened')) {
            body.classList.add('dropdown-opened');
        } else {
            body.classList.remove('dropdown-opened');
        }
    });

    back.addEventListener('click', function (e) {
        e.preventDefault();
        body.classList.remove('dropdown-opened');
    });

    window.addEventListener('click', function () {
        document.body.classList.remove('dropdown-opened');
    });

    document.querySelector('.gh-head').addEventListener('click', function (e) {
        e.stopPropagation();
    });
}

function featured() {
    'use strict';
    var feed = document.querySelector('.featured-feed');
    if (!feed) return;

    tns({
        container: feed,
        controlsText: [
            '<svg class="icon"><use xlink:href="#chevron-left"></use></svg>',
            '<svg class="icon"><use xlink:href="#chevron-right"></use></svg>',
        ],
        gutter: 30,
        loop: false,
        nav: false,
        responsive: {
            0: {
                items: 1,
            },
            768: {
                items: 2,
            },
            992: {
                items: 3,
            },
        },
    });
}

function feedLayout() {
    'use strict';
    var wrapper = document.querySelector('.feed-layout');
    if (!wrapper) return;

    var feed = document.querySelector('.post-feed');

    document.querySelector('.feed-layout-headline').addEventListener('click', function () {
        wrapper.classList.remove('expanded');
        feed.classList.remove('expanded');
        localStorage.setItem('edition_layout', 'compact');
    });

    document.querySelector('.feed-layout-expanded').addEventListener('click', function () {
        wrapper.classList.add('expanded');
        feed.classList.add('expanded');
        localStorage.removeItem('edition_layout');
    });
}

function pagination() {
    'use strict';
    var infScroll;

    if (body.classList.contains('paged-next')) {
        infScroll = new InfiniteScroll('.post-feed', {
            append: '.feed',
            button: '.infinite-scroll-button',
            debug: false,
            hideNav: '.pagination',
            history: false,
            path: '.pagination .older-posts',
            scrollThreshold: false,
            status: '.infinite-scroll-status',
        });

        infScroll.on('append', function (_response, _path, items) {
            items[0].classList.add('feed-paged');
            archive(items);
        });
    }
}

function archive(data) {
    'use strict';
    if (!body.classList.contains('logged-in')) return;

    var posts = data || document.querySelectorAll('.feed');

    posts.forEach(function (post) {
        var current = post.getAttribute('data-month');
        if (current != lastMonth) {
            var month = document.createElement('div');
            month.className = 'feed-month';
            month.innerText = current;

            var group = document.createElement('div');
            group.className = 'feed-group';
            group.appendChild(month);

            feed.insertBefore(group, post);

            group.appendChild(post);

            lastMonth = current;
            lastGroup = group;
        } else {
            lastGroup.appendChild(post);
        }
    });
}

function video() {
    'use strict';
    reframe(document.querySelectorAll('.single-content iframe[src*="youtube.com"], .single-content iframe[src*="vimeo.com"]'));
}

function gallery() {
    'use strict';
    var images = document.querySelectorAll('.kg-gallery-image img');
    images.forEach(function (image) {
        var container = image.closest('.kg-gallery-image');
        var width = image.attributes.width.value;
        var height = image.attributes.height.value;
        var ratio = width / height;
        container.style.flex = ratio + ' 1 0%';
    });

    pswp(
        '.kg-gallery-container',
        '.kg-gallery-image',
        '.kg-gallery-image',
        false,
        true
    );
}

function table() {
    'use strict';
    if (!body.classList.contains('post-template') && !body.classList.contains('page-template')) return;

    var tables = document.querySelectorAll('.single-content .table');

    tables.forEach(function (table) {
        var labels = [];

        table.querySelectorAll('thead th').forEach(function (label) {
            labels.push(label.textContent);
        });

        table.querySelectorAll('tr').forEach(function (row) {
            row.querySelectorAll('td').forEach(function (column, index) {
                column.setAttribute('data-label', labels[index]);
            });
        });
    });
}

function burger() {
    'use strict';
    document.querySelector('.gh-burger').addEventListener('click', function () {
        if (!body.classList.contains('gh-head-open')) {
            body.classList.add('gh-head-open');
        } else {
            body.classList.remove('gh-head-open');
        }
    });
}

function pswp(container, element, trigger, caption, isGallery) {
    var parseThumbnailElements = function (el) {
        var items = [],
            gridEl,
            linkEl,
            item;

        el
            .querySelectorAll(element)
            .forEach(function (v) {
                gridEl = v;
                linkEl = gridEl.querySelector(trigger);

                item = {
                    src: isGallery
                        ? gridEl.querySelector('img').getAttribute('src')
                        : linkEl.getAttribute('href'),
                    w: 0,
                    h: 0,
                };

                if (caption && gridEl.querySelector(caption)) {
                    item.title = gridEl.querySelector(caption).innerHTML;
                }

                items.push(item);
            });

        return items;
    };

    var openPhotoSwipe = function (index, galleryElement) {
        var pswpElement = document.querySelectorAll('.pswp')[0],
            gallery,
            options,
            items;

        items = parseThumbnailElements(galleryElement);

        options = {
            closeOnScroll: false,
            history: false,
            index: index,
            shareEl: false,
            showAnimationDuration: 0,
            showHideOpacity: true,
        };

        gallery = new PhotoSwipe(
            pswpElement,
            PhotoSwipeUI_Default,
            items,
            options
        );
        gallery.listen('gettingData', function (index, item) {
            if (item.w < 1 || item.h < 1) {
                // unknown size
                var img = new Image();
                img.onload = function () {
                    // will get size after load
                    item.w = this.width; // set image width
                    item.h = this.height; // set image height
                    gallery.updateSize(true); // reinit Items
                };
                img.src = item.src; // let's download image
            }
        });
        gallery.init();
    };

    var onThumbnailsClick = function (e) {
        e.preventDefault();

        var siblings = e.target.closest(container).querySelectorAll(element);
        var nodes = Array.prototype.slice.call(siblings);
        var index = nodes.indexOf(e.target.closest(element));
        var clickedGallery = e.target.closest(container);

        openPhotoSwipe(index, clickedGallery);

        return false;
    };

    // container = document.querySelector(container);
    // if (!container) return;

    var triggers = document.querySelectorAll(trigger);
    triggers.forEach(function (trig) {
        trig.addEventListener('click', function (e) {
            onThumbnailsClick(e);
        });
    });
}

/**
 * @typedef {object} AttributionCookieProps
 * @property {string} firstPage
 * @property {string} signupSource
 * @property {string} coupon
 * @property {string} lastPage
 */

/**
* Read UTM campaign data and save in cookie or update existing
*/
function attributionCookies(document) {
    var NINETY_DAYS = 1000 * 60 * 60 * 24 * 90;

    /**
     * Takes a cookie name and returns the value of the cookie
     * @param {string} cookieName
     * @returns {object|null}
     */
    function getCookie(cookieName) {
        if (!cookieName) {
            return null;
        }

        // Add the = sign
        cookieName = cookieName + '=';
        // Get the decoded cookie
        var decodedCookie = decodeURIComponent(document.cookie);
        // Get all cookies, split on ; sign
        var cookies = decodedCookie.split(';');
        // Loop over the cookies
        for (var i = 0; i < cookies.length; i++) {
            // Define the single cookie, and remove whitespace
            var cookie = cookies[i].trim();

            // If this cookie has the name of what we are searching
            if (cookie.indexOf(cookieName) === 0) {
                // Return everything after the cookies name
                try {
                    return JSON.parse(cookie.substring(cookieName.length, cookie.length));
                } catch (error) {
                    return null;
                }
            }
        }
    }

    /**
     * Takes a cookie name, a value and a duration and sets the cookie
     * @param {string} cookieName
     * @param {object} value - will be converted to JSON
     * @param {number?} duration - defaults to 90 days
     * @returns {string} - the set cookie
     */
    function setCookie(cookieName, value, duration) {
        duration = duration || NINETY_DAYS;
        var expiry = new Date(Date.now() + duration);
        var hostname = window.location.hostname;
        var encodedValue = encodeURIComponent(JSON.stringify(value));

        var domain = '.ghost.org';
        var options = '; path=/; expires=' + expiry.toGMTString() + '; samesite=strict';

        // Skip .ghost.org domain restriction for localhost, staging and deploy previews
        if (hostname.endsWith('.ghostfoundation.org')) {
            domain = '.ghostfoundation.org';
        } else if (hostname === 'localhost' || hostname.endsWith('.netlify.app')) {
            domain = '';
        }

        if (domain) {
            options += '; domain=' + domain;
        }

        if (window.location.protocol === 'https:') {
            options += '; secure';
        }

        document.cookie = cookieName + '=' + encodedValue + options;
        return document.cookie;
    }

    /**
     * Reads defined UTM campaign data and returns it as an object
     * @returns {object|null}
     */
    function readCampaignData() {
        var campaign = null;
        // Check, if campaign information got passed via URL and
        // save this information later in a cookie
        var urlParams = new URLSearchParams(window.location.search);

        if (urlParams.has('utm_source') || urlParams.has('utm_medium') || urlParams.has('utm_campaign') || urlParams.has('twclid')) {
            campaign = {};

            // store the query params so we can pass them to the server
            urlParams.forEach(function (value, key) {
                campaign[key] = value;
            });
        }

        return campaign;
    }

    /**
     * @returns {AttributionCookieProps}
     * @todo Add reading FirstPromoter data to here (coupon, FP referrer id, etc.),
     *      see https://linear.app/tryghost/issue/CA-8/allow-external-tools-to-set-coupons
     */
    function readAttributionData() {
        var urlParams = new URLSearchParams(window.location.search);
        var utmSource = urlParams.get('utm_source') || null;
        // if we can't find a referrer, let's see if we have a utm_source
        var signupSource = (document.referrer || utmSource) || null;

        return {
            firstPage: window.location.pathname,
            signupSource: signupSource,
            coupon: urlParams.get('cpn') || null
        };
    }

    /**
     * Catch last page before leaving the site and update the attribution cookie
     * @returns {void}
     */
    function listenForLastPageAction() {
        var allSignupCTAs = document.getElementsByClassName('plausible-event-name=Signup-CTA-clicked');

        for (var index = 0; index < allSignupCTAs.length; index++) {
            var cta = allSignupCTAs[index];
            var originalClickHandler = cta.onclick;
            // Before leaving this site we want to store the last page the user visited
            // and update the attribution cookie
            cta.addEventListener('click', function (e) {
                e.preventDefault();
                try {
                    var attributionCookie = getCookie('_ghost_attr');
                    if (typeof attributionCookie === 'string') {
                        // if the cookie is a string, we need to parse it
                        attributionCookie = JSON.parse(attributionCookie);
                    }
                    if (attributionCookie) {
                        var lastPage = window.location.pathname;
                        // always update the last page before signup
                        attributionCookie.lastPage = lastPage;
                        setCookie('_ghost_attr', attributionCookie);
                    } else {
                        // set the cookie in case it doesn't exist yet
                        var attribution = readAttributionData();
                        var lastPage = window.location.pathname;
                        // always update the last page before signup
                        attribution.lastPage = lastPage;
                        setCookie('_ghost_attr', attribution);
                    }
                } catch (error) {
                    // noop
                }
                // trigger the original event
                if (originalClickHandler) {
                    originalClickHandler.call(cta, e);
                } else if (cta.getAttribute('href')) {
                    window.location.href = cta.getAttribute('href');
                }
            });
        }
    }

    // Handle UTM campaigns incl. Twitter Pixel
    var campaign = readCampaignData();

    if (campaign) {
        var utmCookieOld = getCookie('_utm');

        if (utmCookieOld) {
            // Update only changed properties in our cookie
            campaign = Object.assign({}, utmCookieOld, campaign);
        }

        setCookie('_utm', campaign);
    }

    var currentAttribution = readAttributionData();

    if (currentAttribution) {
        var existingAttribution = getCookie('_ghost_attr');

        if (existingAttribution) {
            if (typeof existingAttribution === 'string') {
                // if the cookie is a string, we need to parse it
                existingAttribution = JSON.parse(existingAttribution);
            }
            // update any unset values on the existing cookie
            if (currentAttribution.coupon && !existingAttribution.coupon) {
                existingAttribution.coupon = currentAttribution.coupon;
            }
            if (currentAttribution.signupSource && !existingAttribution.signupSource) {
                existingAttribution.signupSource = currentAttribution.signupSource;
            }
            if (currentAttribution.firstPage && !existingAttribution.firstPage) {
                existingAttribution.firstPage = currentAttribution.firstPage;
            }
            setCookie('_ghost_attr',existingAttribution);
        } else {
            setCookie('_ghost_attr',currentAttribution);
        }
    }

    if (typeof plausible !== 'undefined' || (typeof window !== 'undefined' && typeof window.plausible !== 'undefined')) {
        var plsbl = plausible || window.plausible;
        plsbl('pageview');
    }

    listenForLastPageAction();
}

document.addEventListener('DOMContentLoaded', function () {
    attributionCookies(document);
});
